import React from 'react';
export const BonusLogo = props => (/*#__PURE__*/React.createElement("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "#FDC300"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0833 4.83333L8.00001 0.666664L0.916672 4.83333V13.1667L8.00001 17.3333L15.0833 13.1667V4.83333ZM8 12.5714C9.93594 12.5714 11.5053 10.9724 11.5053 9C11.5053 7.02755 9.93594 5.42857 8 5.42857C6.06405 5.42857 4.49465 7.02755 4.49465 9C4.49465 10.9724 6.06405 12.5714 8 12.5714Z"
})));